import { createFileRoute } from "@tanstack/react-router";

import { ConsoleAccessOverviewPage } from "@/features/console/pages/AccessOverviewPage";

export const Route = createFileRoute("/_authed/_modal/console/access")({
  validateSearch: (search): { connectionId?: string; documentId?: string } => ({
    connectionId: typeof search.connectionId === "string" ? search.connectionId : undefined,
    documentId: typeof search.documentId === "string" ? search.documentId : undefined,
  }),
  component: function AccessRoute() {
    const { connectionId, documentId } = Route.useSearch();
    return (
      <ConsoleAccessOverviewPage
        initialConnectionId={connectionId}
        initialDocumentId={documentId}
      />
    );
  },
});
